module.exports = __webpack_public_path__ + "static/media/hand-pointer.92629740.svg";